export enum TaskCompletionsTab {
  All = 'all',
  Alert = 'alert',
  Warning = 'warning',
  Success = 'success',
  Media = 'media',
}
